















import { Inject, Ref, Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'
import { cloneDeep } from 'lodash'
import { User } from '@/api/model/user'
import { UserAPI } from '@/api/backend-client'

@Component
export default class ListUsersActions extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) readonly user!: User
    @Ref() wrapper: HTMLDivElement
    visible: boolean = false
    value: User = null

    created(): void {
        this.value = cloneDeep<User>(this.user)
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.wrapper, {
            opacity: 0,
        })

        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }

    async deleteAction(user: User): Promise<void> {
        if (confirm(this.$t('company_settings.users.delete_confirm').toString())) {
            await UserAPI.delete(user.id)
            await this.reloadCompany()
        }
    }

    async navigateToEdit(user: User): Promise<void> {
        await this.$router.push({
            name: 'company_settings_users_edit',
            params: {
                userId: user.id,
            },
        })
    }

    async toggleActive(user: User): Promise<void> {
        user.active = !user.active
        await UserAPI.update(user.id, {
            ...user,
            company: this.$currentCompany,
        } as User)
    }
}
